import { type IKnownBusinessEntity } from "@/interfaces/api/known-business-entity.interface.ts"
import { BaseModel } from "@/models/base.model"
import { RegisteredBusinessEntity } from "@/models/registered-business-entity.model.ts"
import { ModelFactory } from "@/factories/model-factory.ts"
import { ManDaysRegisterMode } from "@/enums/man-days-register-mode.enum.ts"
import countries from "i18n-iso-countries"
import nl from "i18n-iso-countries/langs/nl.json"

countries.registerLocale(nl)

export class KnownBusinessEntity extends BaseModel implements IKnownBusinessEntity {
  public static className = "KnownBusinessEntity" // Used for socket communication.
  public static verboseName = "Bedrijf"

  id?: string

  registeredBusinessEntity: RegisteredBusinessEntity | null

  customName?: string
  countryOfRegistration?: string
  registrationNumber?: string

  manDaysRegisterMode: ManDaysRegisterMode

  comment: string

  public constructor(knownBusinessEntity: IKnownBusinessEntity, managed = false) {
    super(knownBusinessEntity)

    this.id = knownBusinessEntity.id
    this.registeredBusinessEntity = ModelFactory.childModel(
      RegisteredBusinessEntity,
      knownBusinessEntity.registeredBusinessEntity,
      managed
    )
    this.customName = knownBusinessEntity.customName
    this.countryOfRegistration = knownBusinessEntity.countryOfRegistration
    this.registrationNumber = knownBusinessEntity.registrationNumber
    this.manDaysRegisterMode = knownBusinessEntity.manDaysRegisterMode ?? ManDaysRegisterMode.NEVER
    this.comment = knownBusinessEntity.comment
  }

  public get name(): string {
    return this.registeredBusinessEntity?.name || this.customName!
  }

  public getCountryOfRegistrationString(): string {
    let countryCode = this.countryOfRegistration
    if (this.registeredBusinessEntity) {
      countryCode = this.registeredBusinessEntity.countryOfRegistration
    }
    if (!countryCode) {
      return ""
    }
    return countries.getName(countryCode, "nl", { select: "alias" })!
  }

  public getRegistrationNumber(): string {
    let registrationNumber = this.registrationNumber
    if (this.registeredBusinessEntity) {
      registrationNumber = this.registeredBusinessEntity.registrationNumber
    }
    return registrationNumber!
  }
}
